import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
Vue.config.devtools = true;

export const store = new Vuex.Store({
    state: {
        prompted: localStorage.getItem('prompted'),
        submitted: localStorage.getItem('submitted'),
    },
    mutations: {
        setPrompted(state, val) {
            localStorage.setItem('prompted', val);
            state.prompted = val;
        },
        setSubmitted(state, val) {
            localStorage.setItem('submitted', val);
            state.submitted = val;
        },
    },
    getters: {
        prompted: state => {
            return state.prompted;
        },
        submitted: state => {
            return state.submitted;
        },
    }
});